import { render, staticRenderFns } from "./ManagementFooter.vue?vue&type=template&id=5994384f"
import script from "./ManagementFooter.vue?vue&type=script&lang=js"
export * from "./ManagementFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports